import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { startCheckout } from "@/lib/checkout";

export const PricingCard = ({ overline, title, price, includes, exclusion, planId, consultCta }) => {
  return (
    <div className="border border-silver/50 bg-off-white" data-testid={`pricing-${planId}`}>
      <div className="grid lg:grid-cols-2">
        <div className="p-8 lg:p-12 border-b lg:border-b-0 lg:border-r border-silver/50">
          <span className="font-mono-sci text-xs text-blue-gray">{overline}</span>
          <h3 className="mt-4 text-2xl lg:text-3xl text-ink">{title}</h3>
          <div className="mt-8 flex items-baseline gap-2">
            <span className="font-mono-sci text-xs text-dark-gray">FROM</span>
            <span className="text-4xl lg:text-5xl font-medium text-ink tracking-tight">{price}</span>
            <span className="text-dark-gray text-sm">/ month</span>
          </div>
          <div className="mt-10 flex flex-col gap-3">
            <Link to="/contact" data-testid={`${planId}-consult`} className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[13px] font-medium bg-charcoal text-white border border-transparent hover:border-acid transition-all group">
              {consultCta}
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <button onClick={() => startCheckout(planId)} data-testid={`${planId}-subscribe`} className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[13px] font-medium bg-acid text-charcoal hover:bg-acid-dark transition-all">
              Subscribe
            </button>
          </div>
        </div>
        <div className="p-8 lg:p-12">
          <p className="overline mb-6">Included</p>
          <ul className="space-y-3.5">
            {includes.map((it) => (
              <li key={it} className="flex items-start gap-3">
                <Check size={16} className="text-acid-dark mt-0.5 shrink-0" />
                <span className="text-sm text-dark-gray leading-relaxed">{it}</span>
              </li>
            ))}
          </ul>
          <p className="mt-8 pt-6 border-t border-silver/50 text-xs text-dark-gray leading-relaxed">{exclusion}</p>
        </div>
      </div>
    </div>
  );
};
